import { fetchJSON } from '@bonnet/next/fetch';

export default ({ vin, zip }) => fetchJSON(`/marketplace/api/public/listings/${vin}/delivery/${zip}`, {
    circuitBreaker: {
        id: 'psxDeliveryEstimate',
        timeout: 8000,
        resetTimeout: 30000,
        fallback: {
            results: false,
        },
        // API returns 400 when delivery distance not > unknown minimum
        // we don't want to trip the breaker with that
        errorFilter: (error) => error?.status === 400,
    },
}).catch((error) => {
    // eslint-disable-next-line no-console
    console.log('PSX Delivery Estimate API call failed', error);
});
